/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconWifi0 = createReactComponent("outline", "wifi-0", "IconWifi0", [["path", { "d": "M12 18l.01 0", "key": "svg-0" }]]);

export { IconWifi0 as default };
//# sourceMappingURL=IconWifi0.mjs.map
